import React from 'react';
import { Users } from 'lucide-react';
import { useSharedBoards } from '@/hooks/useSharedBoards';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface SharedBoardsButtonProps {
  onClick: () => void;
}

export function SharedBoardsButton({ onClick }: SharedBoardsButtonProps) {
  const { sharedBoards, isLoading } = useSharedBoards();

  // Don't show if no shared boards
  if (isLoading || sharedBoards.length === 0) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          onClick={onClick}
          variant="outline"
          className="
            fixed right-4 top-20 z-30
            flex items-center gap-2
            px-4 py-3
            bg-background
            rounded-xl
            shadow-sm
            border border-border
            hover:shadow-md
            transition-shadow
          "
        >
          <Users className="w-5 h-5 text-primary" />
          <span className="text-sm font-medium text-foreground">Shared with me</span>
          <span className="px-2 py-0.5 bg-primary/10 text-primary text-xs font-medium rounded-full">
            {sharedBoards.length}
          </span>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="left">
        <p>View boards shared with you</p>
      </TooltipContent>
    </Tooltip>
  );
}
